import React from 'react'

const BLOB_COUNT = 15

const LiveCasinoHeader = () => (
  <div className="live-casino-header">
    <img
      className="live-casino-header__img"
      src="/livecasinoLobby.16d18b4a.svg"
      alt=""
    />
    <div className="live-casino-lamp">
      <div className="live-casino-lava">
        <div className="live-casino-header__text">
          <div className="live-casino-header__text-name animate-charcter">
            Live Casino
          </div>
          <div className="live-casino-header__text-credo">Play. Win. Enjoy.</div>
        </div>
        {Array.from({ length: BLOB_COUNT }).map((_, i) => (
          <div key={i} className="live-casino-blob" />
        ))}
        <div className="live-casino-blob2">
          <svg xmlns="http://www.w3.org/2000/svg" fill="url(#liveCasinoGradient)" viewBox="0 0 310 350">
            <path d="M156.4,339.5c31.8-2.5,59.4-26.8,80.2-48.5c28.3-29.5,40.5-47,56.1-85.1c14-34.3,20.7-75.6,2.3-111c-18.1-34.8-55.7-58-90.4-72.3c-11.7-4.8-24.1-8.8-36.8-11.5l-0.9-0.9l-0.6,0.6c-27.7-5.8-56.6-6-82.4,3c-38.8,13.6-64,48.8-66.8,90.3c-3,43.9,17.8,88.3,33.7,128.8c5.3,13.5,10.4,27.1,14.9,40.9C77.5,309.9,111,343,156.4,339.5z" />
            <defs>
              <linearGradient id="liveCasinoGradient" gradientTransform="rotate(90)">
                <stop offset="0%" stopColor="#eeaeca" />
                <stop offset="10%" stopColor="#d99cce" />
                <stop offset="24%" stopColor="#de86e9" />
                <stop offset="47%" stopColor="#c996e9" />
                <stop offset="68%" stopColor="#a5aee9" />
                <stop offset="100%" stopColor="#94bbe9" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div className="live-casino-blob3">
          <svg xmlns="http://www.w3.org/2000/svg" fill="url(#liveCasinoGradient2)" viewBox="0 0 310 350">
            <path d="M156.4,339.5c31.8-2.5,59.4-26.8,80.2-48.5c28.3-29.5,40.5-47,56.1-85.1c14-34.3,20.7-75.6,2.3-111c-18.1-34.8-55.7-58-90.4-72.3c-11.7-4.8-24.1-8.8-36.8-11.5l-0.9-0.9l-0.6,0.6c-27.7-5.8-56.6-6-82.4,3c-38.8,13.6-64,48.8-66.8,90.3c-3,43.9,17.8,88.3,33.7,128.8c5.3,13.5,10.4,27.1,14.9,40.9C77.5,309.9,111,343,156.4,339.5z" />
            <defs>
              <linearGradient id="liveCasinoGradient2" gradientTransform="rotate(90)">
                <stop offset="0%" stopColor="#eeaeca" />
                <stop offset="10%" stopColor="#d99cce" />
                <stop offset="24%" stopColor="#de86e9" />
                <stop offset="47%" stopColor="#c996e9" />
                <stop offset="68%" stopColor="#a5aee9" />
                <stop offset="100%" stopColor="#94bbe9" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </div>
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" className="live-casino-goo-svg">
        <defs>
          <filter id="goo">
            <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
            <feColorMatrix
              in="blur"
              mode="matrix"
              values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7"
              result="goo"
            />
            <feBlend in="SourceGraphic" in2="goo" />
          </filter>
        </defs>
      </svg>
    </div>
  </div>
)

export default LiveCasinoHeader
